import { render, staticRenderFns } from "./GasConsumptionView.vue?vue&type=template&id=456e32b2&"
import script from "./GasConsumptionView.vue?vue&type=script&lang=ts&"
export * from "./GasConsumptionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports